import * as React from 'react'
import { ResponseNodeE } from './kind'

export const CopyPasteContext = React.createContext<{copiedData:null|ResponseNodeE,setCopiedData: (copiedData: ResponseNodeE|null) => void}>({
    copiedData: null,
    setCopiedData: (copiedData: ResponseNodeE|null) => {},
})
